module.exports = __webpack_public_path__ + "static/media/puzzle-39-bg.c4c62e2c.svg";